import { gql, TypedDocumentNode } from '@apollo/client'
import type { UserPermissionFragment } from './__generated__/UserPermissionFragment'

export const userPermissionFragment: TypedDocumentNode<UserPermissionFragment> = gql`
  fragment UserPermissionFragment on UserPermission {
    companyId
    companyName
    construct4dPermissions {
      id
      permissions
    }
    interim4dPermissions {
      id
      permissions
    }
    vat
  }
`
